const pub = {
  // 正式的
  Src: "https://ca.jianxiangjiaoyu.com",
  Url: "https://ca.jianxiangjiaoyu.com/hdkt/",
  // 测试版本
  // Src: "https://catest.jianxiangjiaoyu.com",
  // Url: "https://catest.jianxiangjiaoyu.com/hdkt/",
  //开发环境
  // Src: "http://192.168.1.23:8088",
  // Url: "http://192.168.1.23:8088/hdkt/",
  /**
   * 秒数转小时分钟秒字符串
   * @param {Object} result秒数
   */
  secondToDate: (result) => {
    var h = Math.floor(result / 3600) < 10 ? "0" + Math.floor(result / 3600) : Math.floor(result / 3600);
    var m = Math.floor((result / 60) % 60) < 10 ? "0" + Math.floor((result / 60) % 60) : Math.floor((result / 60) % 60);
    var s = Math.floor(result % 60) < 10 ? "0" + Math.floor(result % 60) : Math.floor(result % 60);
    return (result = h + ":" + m + ":" + s);
  },
  formatDate(dateParam) {
    const date = dateParam ? new Date(dateParam) : new Date("0000/00/00");
    const year = date.getFullYear(); // 获取当前年
    const month = ("0" + (date.getMonth() + 1)).slice(-2); // 获取当前月并补零
    const day = ("0" + date.getDate()).slice(-2); // 获取当前日并补零
    return `${year}/${month}/${day}`;
  },
numberToChinese(num) {
    if (num < 0 || num > 9) {
      throw new Error("num must be in range [0, 9]");
    }
    const digits = "零一二三四五六七八九";
    return digits[num];
  },
  deepClone(obj) { // 公共深拷贝方法
    return JSON.parse(JSON.stringify(obj))
  },
  getPlatform() { // 获取当前平台
    let platform;
    // console.log(window.__wxjs_environment, window.navigator.userAgent);

    if (typeof window !== 'undefined' && window.__wxjs_environment) {
      platform = 'weapp'; // 微信小程序环境
    } else if (typeof window !== 'undefined' && window.navigator.userAgent.includes('Android') || window.navigator.userAgent.includes('iPhone')) { // /* 其他App环境的检测逻辑 */
      platform = 'app'; // App环境
    } else {
      platform = 'web'; // H5环境
    }

    return platform;
  },
  isDevice() {//判断是微信还是android还是ios还是web
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return 'Wx';
    }
    if (ua.match(/iPhone\sOS/i) == "iphone os" || ua.match(/iPad/i) == "ipad") {//ios
      return "iOS";
    }
    if (ua.match(/Android/i) == "android") {
      return "Android";
    }
    return "Web";
  },
  /* 获取一段HTML文本中的纯文本内容 */
  htmlToText(html) {
    // 创建一个新的DOMParser实例
    var parser = new DOMParser();

    // 使用DOMParser的parseFromString方法将HTML字符串转换为Document对象
    var doc = parser.parseFromString(html, "text/html");

    // 定义一个函数来递归提取所有文本节点的内容
    function extractText(node) {
      var text = "";
      if (node.nodeType === Node.TEXT_NODE) {
        text += node.textContent;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        for (var i = 0; i < node.childNodes.length; i++) {
          text += extractText(node.childNodes[i]);
        }
      }
      return text;
    }

    // 从Document对象的body开始提取文本
    return extractText(doc.body);
  },
	/* 计算多选题得分，0分、满分、部分分（满分的一半） */
	calculateScore(correctAnswer, studentAnswer, fullScore) {
	    const studentSet = new Set(studentAnswer.split(''));
			if (studentSet.size == 0) {
				return 0;
			}
			
			const correctSet = new Set(correctAnswer.split(''));
	
	    // 检查是否有错误选项
	    for (const answer of studentSet) {
	        if (!correctSet.has(answer)) {
	            return 0;
	        }
	    }
	
	    // 检查是否全选对
	    if (correctSet.size === studentSet.size) {
	        return fullScore;  // 满分
	    }
	
	    // 选对但没有选全，得部分分（满分的一半向下取整）
	    return Math.floor(fullScore / 2);
			// 选对但没有选全，得部分分（满分的一半向上取整）
			// return Math.ceil(fullScore / 2);
	},
	/*计算多选题isRight得分率，有错误项0、全对1、没选全0.5*/
	calculateRight(correctAnswer, studentAnswer) {
	    const studentSet = new Set(studentAnswer.split(''));
	    if (studentSet.size == 0) {
	    	return 0;
	    }
	    
	    const correctSet = new Set(correctAnswer.split(''));
	
	    // 检查是否有错误选项
	    for (const answer of studentSet) {
	        if (!correctSet.has(answer)) {
	            return 0;
	        }
	    }
	
	    // 检查是否全选对
	    if (correctSet.size === studentSet.size) {
	        return 1;  // 满分
	    }
	
	    return 0.5;
	},
	/* 计算多选题得分（按选对项数比例得分） */
	calculateScoreByCount(correctAnswer, studentAnswer, fullScore) {
	    const studentSet = new Set(studentAnswer.split(''));
	    if (studentSet.size == 0) {
	    	return 0;
	    }
	    
	    const correctSet = new Set(correctAnswer.split(''));
	
	    // 检查是否有错误选项
	    for (const answer of studentSet) {
	        if (!correctSet.has(answer)) {
	            return 0;
	        }
	    }
	
	    // 检查是否全选对
	    if (correctSet.size === studentSet.size) {
	        return fullScore;  // 满分
	    }
	
			let correctCount = correctSet.size;
	    let selectedCount = studentSet.size;
	
	    // 计算得分
	    return Math.floor(fullScore / correctCount * selectedCount);
	},
	/* 计算多选题得分率（按选对项数比例得分） */
	calculateRightByCount(correctAnswer, studentAnswer) {
	    const studentSet = new Set(studentAnswer.split(''));
	    if (studentSet.size == 0) {
	    	return 0;
	    }
	    
	    const correctSet = new Set(correctAnswer.split(''));
	
	    // 检查是否有错误选项
	    for (const answer of studentSet) {
	        if (!correctSet.has(answer)) {
	            return 0;
	        }
	    }
	
	    // 检查是否全选对
	    if (correctSet.size === studentSet.size) {
	        return 1;  // 满分
	    }
	
			let correctCount = correctSet.size;
	    let selectedCount = studentSet.size;
	
	    // 计算得分
	    return Math.floor(selectedCount / correctCount * 100) / 100;
	}
};

export default pub;
// console.log(pub.calculateRightByCount('ABC',''));
// console.log(pub.calculateRightByCount('ABC','A'));
// console.log(pub.calculateRightByCount('ABC','B'));
// console.log(pub.calculateRightByCount('ABC','C'));
// console.log(pub.calculateRightByCount('ABC','AB'));
// console.log(pub.calculateRightByCount('ABC','AC'));
// console.log(pub.calculateRightByCount('ABC','BC'));
// console.log(pub.calculateRightByCount('ABC','AD'));
// console.log(pub.calculateRightByCount('ABC','ABC'));
// console.log(pub.calculateRight('BC','ABC'));



// WEBPACK FOOTER //
// ./src/assets/js/public.js